import styled, { keyframes } from 'styled-components';
import { Color } from '../../styles/styles.interface';

const flashingAnimation = (color: Color) => keyframes`
  0% {
    background-color: ${color.default};
  }
  50%,
  100% {
    background-color: ${color.dark};
  }
`;

export const LoadingDots = styled.div`
  align-items: center;
  animation-delay: 0.5s;
  animation: ${({ theme }) => flashingAnimation(theme.color.neutral)} 1s infinite alternate;
  background-color: ${({ theme }) => theme.typography.color.tertiary};
  border-radius: 1.75px;
  color: ${({ theme }) => theme.typography.color.tertiary};
  display: flex;
  height: 3.5px;
  justify-content: center;
  left: -200px;
  position: relative;
  top: 4px;
  width: 3.5px;

  &:before,
  &:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  &:before {
    animation-delay: 0s;
    animation: ${({ theme }) => flashingAnimation(theme.color.neutral)} 1s infinite alternate;
    background-color: ${({ theme }) => theme.color.neutral.default};
    border-radius: 1.75px;
    color: ${({ theme }) => theme.color.neutral.default};
    left: -10px;
    height: 3.5px;
    width: 3.5px;
  }

  &:after {
    animation-delay: 1s;
    animation: ${({ theme }) => flashingAnimation(theme.color.neutral)} 1s infinite alternate;
    background-color: ${({ theme }) => theme.color.neutral.default};
    border-radius: 1.75px;
    color: ${({ theme }) => theme.color.neutral.default};
    left: 10px;
    height: 3.5px;
    width: 3.5px;
  }
`;

export const BoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  height: 58px;
  border: 1px solid ${({ theme }) => theme.color.neutral.default};
`;

export const LoadingLabel = styled.label`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.typography.color.tertiary};
  font-size: ${({ theme }) => theme.typography.size.medium};
`;

export const LoadingDotsContainer = styled.div`
  display: flex;
  align-items: center;
`;
